import React, { useCallback, useState } from 'react';

import { ResetButton } from '@pkg/components/Sections/Admin/components/StyledComponents/styles';
import { useAppDispatch, useAppSelector, useSetUserFeatures } from '@pkg/hooks';
import { getObjectKeys } from '@pkg/types';

import { splitFeatureFlag, toggleFeatureFlag } from '@app/helpers';
import { addNotification } from '@app/store/actions/notification';
import { setFeatures } from '@app/store/slices/features';

export const FeatureFlagManager = () => {
    const features = useAppSelector((state) => state.featureFlags.features);
    const isAuthenticated = useAppSelector((state) => state.user.isRegisteredUser);
    const userId = useAppSelector((state) => state.user.userClass?.user?.user.id);
    const [filter, setFilter] = useState('');
    const dispatch = useAppDispatch();

    const { mutate: setUserFeatures } = useSetUserFeatures();

    const toggle = useCallback(
        (key) => {
            const ff = toggleFeatureFlag(key, features);
            dispatch(setFeatures(ff));

            if (ff && isAuthenticated && userId) {
                setUserFeatures(
                    { id: userId, value: { value: ff } },
                    {
                        onSuccess() {
                            dispatch(addNotification({ message: 'success' }));
                        },
                    },
                );
            }
        },
        [dispatch, features, isAuthenticated, setUserFeatures, userId],
    );

    const featArr = getObjectKeys(features);
    const commonlyToggled = featArr.filter((f) => f.startsWith('show')).sort();
    const rest = featArr.filter((f) => !commonlyToggled.includes(f)).sort();

    const listMarkup = (list) => {
        const filteredList =
            filter &&
            list.filter((key) => {
                const cleanedFilter = filter.toLowerCase().replace(' ', '');
                const loweredKey = splitFeatureFlag(key).toLowerCase().replaceAll(' ', '') as string;
                return loweredKey.includes(cleanedFilter);
            });
        const featureList = filter ? filteredList : list;
        return featureList.map((key, i) => (
            <div className="admin-info__item admin-info__item--ff" key={`${key} + ${i}`}>
                <div className="admin-info__item-title">{splitFeatureFlag(key)}</div>
                <ResetButton
                    onClick={() => toggle(key)}
                    className="admin-info__item-data"
                    style={{ color: features[key] ? 'limegreen' : 'maroon' }}
                >
                    {features[key] ? 'On' : 'Off'}
                </ResetButton>
            </div>
        ));
    };

    return (
        <div>
            <div>
                <input
                    style={{ marginBottom: 10, width: '98%' }}
                    placeholder="Filter features"
                    type="text"
                    onChange={(e) => setFilter(e.target.value)}
                />
            </div>
            {listMarkup(commonlyToggled)}
            <hr />
            {listMarkup(rest)}
        </div>
    );
};
